<template>
<li>
    <!--<img :src="reviewImg" width="30px">-->
    <div>

        <dl>
            <dt>
                <span class="name">{{showName}}</span>
                <span class="car_name">{{title}}</span>
            </dt>
            <dd>
                {{reviewDate}}
                <div>
                    <star-rating
                        :rating="rating"
                        :increment="0.5"
                        :max-rating="5"
                        :fixed-points="1"
                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                        inactive-color="#E9EAEC"
                        active-color="#FFE78A"
                        :star-size="15"
                        text-class = ''
                        read-only>
                    </star-rating>
                </div>
            </dd>
        </dl>
    <!-- :class="{ 'reviewHide' : hide }" @click="hide = !hide;"-->
        <p>{{content}}</p>

    </div>
</li>
</template>

<script>
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';
import StarRating  from "vue-star-rating";
    export default {
        name:'ReviewItem',
        mixins: [ NumberFormatMixin ],
        components: { 
            StarRating
        },
        props: {
            createDt: {
                type: String,
                default: '',
            },
            score:{
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            content:{
                type: String,
                default: '',
            },
            rating :{ 
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                hide: true,
            }
        },
        computed: {
            STATE_RESOURCE() {
                return this.$store.state.resource;
            },
            REVIEW_SCORE() {
                return this.$store.state.codeDictionary.items.REVIEW_SCORE;
            },
            showName() {
                let originStr = this.name;
                // let strLength = originStr.length; 
                
                // if(strLength < 3){ 
                //     maskingStr = originStr.replace(/(?<=.{1})./gi, "*"); 
                // }

                // else { 
                //     maskingStr = originStr.replace(/(?<=.{2})./gi, "*"); 
                // } 

                return originStr;
            },
            reviewImg() {
                let url = '';
                
                switch (this.score) {
                    case this.REVIEW_SCORE.GOOD.id : 
                        url = this.STATE_RESOURCE.imgReviewGood; break;
                    case this.REVIEW_SCORE.NORMAL.id : 
                        url = this.STATE_RESOURCE.imgReviewNormal; break;
                    case this.REVIEW_SCORE.BAD.id : 
                        url = this.STATE_RESOURCE.imgReviewBad; break;
                }

                return url;
            },
            reviewDate() {
                return this.createDt 
            },
        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>

</style>